export default "__VITE_ASSET__DXcqzIBR__"